var exports = {
  "kL": "xcc377c0b--0b02be--container",
  "wx": "xcc377c0b--0b02be--header",
  "Qs": "xcc377c0b--0b02be--content",
  "AS": "xcc377c0b--0b02be--item",
  "DD": "xcc377c0b--0b02be--title",
};

module.exports = exports;
